import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-size",
  "use": "icon-size-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-size\"><path d=\"M0.56 438.936001h437.888535v146.127998H292.488354V1023.44H146.520181V585.063999H0.56V438.936001z m1021.737251-292.248003H735.235569V1023.44H579.57401V146.687998H292.512327V0.56h729.808898l-0.023974 146.127998z\" p-id=\"1705\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol